import { Typography, Select, Button, Space } from 'antd';
import { PlusOutlined, ToTopOutlined, EditOutlined, ShopOutlined } from '@ant-design/icons';
import PageVersionStatus from '../pageversion/pageversionstatus';
import PageVersionActiveStatus from '../pageversion/pageversionactivestatus';

interface PageVersionActionBarProps {
    loading: boolean;
    pageVersionName: string;
    availablePageVersions: { guid: string; name: string }[];
    pageVersionStatus: string;
    isPageVersionActive: boolean;
    onChange: (value: string) => void;
    onCreate: () => void;
    onPublish: () => void;
    onEdit: () => void;
    onDuplicate: () => void;
    onSimulator: () => void;
    onShowStores: () => void;
}

const PageVersionActionBar: React.FC<PageVersionActionBarProps> = ({
    loading,
    pageVersionName,
    availablePageVersions,
    pageVersionStatus,
    isPageVersionActive,
    onChange,
    onCreate,
    onPublish,
    onEdit,
    onDuplicate,
    onSimulator,
    onShowStores,
}) => {
    return (
        <Space style={{ marginBottom: '10px', flexShrink: 0 }}>
            <Typography.Title level={2} style={{ fontWeight: 'normal', whiteSpace: 'normal', wordBreak: 'break-word', marginBottom: 0 }}>
                <strong>Page Version</strong>
            </Typography.Title>

            {loading ? (
                <Select loading style={{ width: '20vw', marginLeft: '16px' }} />
            ) : (
                <>
                    <Select
                        showSearch
                        placeholder="Select a Kiosk Page Version"
                        optionFilterProp="children"
                        onChange={onChange}
                        value={pageVersionName}
                        style={{ width: '20vw', marginLeft: '16px' }}
                        filterOption={(input, option) => {
                            const label = option?.children;
                            return typeof label === 'string' && (label as string).toLowerCase().includes(input.toLowerCase());
                        }}
                    >
                        {availablePageVersions.map((pv) => (
                            <Select.Option key={pv.guid} value={pv.guid}>
                                {pv.name || pv.guid}
                            </Select.Option>
                        ))}
                    </Select>

                    <PageVersionStatus status={pageVersionStatus} />
                    <PageVersionActiveStatus isActive={isPageVersionActive} />

                    {pageVersionStatus !== 'draft' && (
                        <Button icon={<ShopOutlined />} onClick={onShowStores} color="primary" variant="filled">
                            Stores
                        </Button>
                    )}

                    <Button icon={<PlusOutlined />} onClick={onCreate} color="primary" variant="filled">
                        Create New PageVersion
                    </Button>

                    <Button onClick={onSimulator} color="primary" variant="filled">Simulator</Button>

                    {pageVersionStatus === 'draft' ? (
                        <Button icon={<ToTopOutlined />} onClick={onPublish} color="magenta" variant="filled">
                            Publish
                        </Button>
                    ) : pageVersionStatus === 'finalized' && isPageVersionActive ? (
                        <Button icon={<EditOutlined />} onClick={onEdit} color="magenta" variant="filled">
                            Edit
                        </Button>
                    ) : null}

                    {pageVersionStatus !== 'pending approval' && (
                        <Button onClick={onDuplicate} color="magenta" variant="filled">Duplicate</Button>
                    )}
                </>
            )}
        </Space>
    );
};

export default PageVersionActionBar;